module.exports = __webpack_public_path__ + "static/media/Split-Payment.47cc606e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/payments/Split-Payment.png
// module id = 119
// module chunks = 0